var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { DelegationOption } from '@/common/types/DelegationOption';
import { EstimateType } from '@/common/types/EstimateType';
import LabelControl from '@/common/components/LabelControl.vue';
import PlainTextControl from '@/common/components/PlainTextControl.vue';
import PersonnelExpensesControl from '@/template/components/aidApplication/budgetaryEstimate/expenses/PersonnelExpensesControl.vue';
import GeneralExpensesControl from '@/template/components/aidApplication/budgetaryEstimate/expenses/GeneralExpensesControl.vue';
import OtherExpensesControl from '@/template/components/aidApplication/budgetaryEstimate/expenses/OtherExpensesControl.vue';
import EstimatesControl from '@/template/components/aidApplication/budgetaryEstimate/EstimatesControl.vue';
import DelegationControl from '@/template/components/aidApplication/budgetaryEstimate/DelegationControl.vue';
import Estimates, { createEmptyEstimateItem } from '@/common/types/Estimates';
import EstimateItemWrapper from '@/common/types/EstimateItemWrapper';
import EstimatesAndDetailsControl from '@/template/components/aidApplication/budgetaryEstimate/EstimatesAndDetailsControl.vue';
import PremisesControl from '@/template/components/aidApplication/controls/PremisesControl.vue';
import SupportApartmentsBudgetaryEstimateView from '@/template/components/aidApplication/investment/SupportApartmentsBudgetaryEstimateView.vue';
import PremisesBudgetaryEstimateView from '@/template/components/aidApplication/investment/PremisesBudgetaryEstimateView.vue';
import IctBudgetaryEstimateView from '@/template/components/aidApplication/investment/ICTBudgetaryEstimateView.vue';
import AttachmentRow from '@/common/components/AttachmentRow.vue';
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import { BudgetaryEstimate } from '@/common/types/BudgetaryEstimate';
import { AidTypeSpecification } from '@/common/types/AidTypeSpecification';
import { Savable } from '@/common/mixins/Savable';
var BudgetaryEstimateView = /** @class */ (function (_super) {
    __extends(BudgetaryEstimateView, _super);
    function BudgetaryEstimateView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BudgetaryEstimateView.prototype, "isAy", {
        get: function () {
            return this.specification.isAy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "isPlaceOpen", {
        get: function () {
            return this.specification.isPlaceOpen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "isPremisesRenovationOrImprovement", {
        get: function () {
            return this.specification.isPremisesRenovationOrImprovement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "isSupportApartments", {
        get: function () {
            return this.specification.isSupportApartments;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "isICT", {
        get: function () {
            return this.specification.isICT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "bAidType", {
        get: function () {
            return this.specification.bAidType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "hasProcuration", {
        get: function () {
            return this.$store.getters["vuexPageModule/hasProcuration"];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "attachment", {
        get: function () {
            return this.budgetaryEstimate.attachment;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "investment", {
        get: function () {
            return this.budgetaryEstimate.investment;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "profits", {
        /**
         *
         * Profits
         *
         */
        get: function () {
            return this.budgetaryEstimate.profits;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "profitEstimates", {
        get: function () {
            return new Estimates(this.profits.breakdown);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Generator method for creating new profit estimates
     * */
    BudgetaryEstimateView.prototype.createProfitEstimate = function () {
        var item = createEmptyEstimateItem(this.applicationYear);
        return item;
    };
    Object.defineProperty(BudgetaryEstimateView.prototype, "showGrantorsAndPurposes", {
        get: function () {
            if (!this.bAidType)
                return this.profits.breakdown.findIndex(function (x) { return x.type == EstimateType.Profits_Other || x.type == EstimateType.Profits_OtherPublicAid; }) != -1;
            return false;
        },
        enumerable: false,
        configurable: true
    });
    BudgetaryEstimateView.prototype.onManuallyAddedProfitsChange = function (value) {
        if (!value) {
            this.profits.grantorsAndPurposes = "";
            this.forceSave();
        }
    };
    BudgetaryEstimateView.prototype.createDelegationEstimate = function () {
        var item = createEmptyEstimateItem(this.applicationYear);
        item.type = EstimateType.Expenses_Delegation_Partner;
        return item;
    };
    Object.defineProperty(BudgetaryEstimateView.prototype, "expenses", {
        get: function () {
            return this.budgetaryEstimate.expenses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "premises", {
        get: function () {
            return this.budgetaryEstimate.expenses.premises;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "delegatedAid", {
        get: function () {
            return this.budgetaryEstimate.expenses.delegatedAid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "totalExpensesItem", {
        get: function () {
            var e_1, _a;
            var general = (!this.isAy && !this.isPlaceOpen)
                ? new Estimates(this.generalExpenses.breakdown)
                : null;
            var personnel = new Estimates(this.personnelExpenses.yearlyPersonnelExpenses);
            var operational = new Estimates(this.operationalExpenses);
            var other = new Estimates(this.otherExpenses.summary);
            var expensesItem = {
                name: "BudgetaryEstimate.Total.Expenses",
                isReadOnly: true,
                yearlyItems: [],
                canDelete: false
            };
            try {
                for (var _b = __values(personnel.years), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var year = _c.value;
                    var total = ((!this.isAy && !this.isPlaceOpen) ? general.yearlyTotal(year) : 0)
                        + personnel.yearlyTotal(year)
                        + operational.yearlyTotal(year)
                        + other.yearlyTotal(year)
                        + ((!this.isAy && !this.isPlaceOpen) ? this.delegationTotal[year - this.applicationYear] : 0);
                    expensesItem.yearlyItems.push({ year: year, isReadOnly: true, isRequired: false, value: total });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return expensesItem;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "totalProfitsItem", {
        get: function () {
            var e_2, _a;
            var profits = new Estimates(this.profits.breakdown);
            var profitsItem = {
                name: "BudgetaryEstimate.Total.Profits",
                isReadOnly: true,
                yearlyItems: [],
                canDelete: false
            };
            try {
                for (var _b = __values(profits.years), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var year = _c.value;
                    profitsItem.yearlyItems.push({ year: year, isReadOnly: true, isRequired: false, value: profits.yearlyTotal(year) });
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return profitsItem;
        },
        enumerable: false,
        configurable: true
    });
    BudgetaryEstimateView.prototype.computeTotalsYearlyTotal = function (year) {
        var value = this.totalProfitsItem.yearlyItems.find(function (x) { return x.year == year; }).value - this.totalExpensesItem.yearlyItems.find(function (x) { return x.year == year; }).value;
        return Number.isInteger(value) ? value : 0;
    };
    Object.defineProperty(BudgetaryEstimateView.prototype, "totalSummary", {
        /**
         * Calculates total expenses and profits
         */
        get: function () {
            return new Estimates([this.totalProfitsItem, this.totalExpensesItem], this.computeTotalsYearlyTotal);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "delegationTotal", {
        /**
         * Calculates total delegation expenses
         */
        get: function () {
            var e_3, _a;
            var delegationItems = null;
            if (this.delegatedAid.delegatedTo == DelegationOption.DelegatedToMember)
                delegationItems = this.delegatedAid.yearlyMemberDelegationTotals;
            else if (this.delegatedAid.delegatedTo == DelegationOption.DelegatedToPartner)
                delegationItems = this.delegatedAid.yearlyPartnerDelegationTotals;
            if (delegationItems && delegationItems.length > 0) {
                var delegation = new Estimates(delegationItems);
                var yearlyTotals = [];
                try {
                    for (var _b = __values(delegation.years), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var year = _c.value;
                        yearlyTotals.push(delegation.yearlyTotal(year));
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                return yearlyTotals;
            }
            else {
                return [0, 0, 0];
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "otherExpenses", {
        get: function () {
            return this.budgetaryEstimate.expenses.otherExpenses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "personnelExpenses", {
        get: function () {
            return this.budgetaryEstimate.expenses.personnelExpenses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "operationalExpenseWrappers", {
        /**
         *
         *  Operational expenses
         *
         */
        get: function () {
            return this.buildWrappersOperationExpenses();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "operationalExpenses", {
        get: function () {
            return this.expenses.operationalExpenses.breakdown;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "features", {
        get: function () {
            var config = this.$store.state.vuexPageModule.configuration;
            return config.featureConfiguration;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Wraps operational expenses and sets up explanation rules for each item
     * */
    BudgetaryEstimateView.prototype.buildWrappersOperationExpenses = function () {
        var e_4, _a;
        var _this = this;
        var wrappers = [];
        var _loop_1 = function (expense) {
            if (expense.type === EstimateType.Expenses_Operational_ExternalServices) {
                wrappers.push(new EstimateItemWrapper(expense, function () { return expense.yearlyItems[0].value > _this.features.explanationLimit_ExternalServices; }, function () { return expense.yearlyItems[0].value > _this.features.explanationCoefficient_ExternalServices * _this.totalExpensesItem.yearlyItems[0].value; }));
            }
            else if (expense.type === EstimateType.Expenses_Operational_Procurements) {
                wrappers.push(new EstimateItemWrapper(expense, function () { return expense.yearlyItems[0].value > _this.features.explanationLimit_Procurements; }, function () { return expense.yearlyItems[0].value > _this.features.explanationCoefficient_Procurements * _this.totalExpensesItem.yearlyItems[0].value; }));
            }
            else if (expense.type === EstimateType.Expenses_Operational_Travel) {
                wrappers.push(new EstimateItemWrapper(expense, function () { return expense.yearlyItems[0].value > _this.features.explanationLimit_Travel; }, function () { return expense.yearlyItems[0].value > _this.features.explanationCoefficient_Travel * _this.totalExpensesItem.yearlyItems[0].value; }));
            }
            else if (expense.type === EstimateType.Expenses_Operational_Other) {
                wrappers.push(new EstimateItemWrapper(expense, function () { return expense.yearlyItems[0].value > _this.features.explanationLimit_Other; }, function () { return expense.yearlyItems[0].value > _this.features.explanationCoefficient_Other * _this.totalExpensesItem.yearlyItems[0].value; }));
            }
        };
        try {
            for (var _b = __values(this.operationalExpenses), _c = _b.next(); !_c.done; _c = _b.next()) {
                var expense = _c.value;
                _loop_1(expense);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return wrappers;
    };
    Object.defineProperty(BudgetaryEstimateView.prototype, "generalExpenses", {
        get: function () {
            return this.budgetaryEstimate.expenses.generalExpenses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BudgetaryEstimateView.prototype, "premisesSelected", {
        get: function () {
            return this.budgetaryEstimate.expenses.premises.premiseTypes && this.budgetaryEstimate.expenses.premises.premiseTypes.length != 0;
        },
        enumerable: false,
        configurable: true
    });
    BudgetaryEstimateView.prototype.profitsNumericInputRules = function (estimateType, year) {
        var rulesArray = {};
        if (estimateType == EstimateType.Profits_AppliedAid && year == this.applicationYear) {
            Object.assign(rulesArray, { min_value: 1 });
        }
        if (this.isPremisesRenovationOrImprovement || this.isSupportApartments) {
            if (estimateType == EstimateType.Profits_SelfCoveredFunding && year == this.applicationYear)
                Object.assign(rulesArray, { min_value: 1 });
        }
        return rulesArray;
    };
    Object.defineProperty(BudgetaryEstimateView.prototype, "otherProfitOptions", {
        get: function () {
            var optionsArray = [
                this.getEstimateTypeOption(EstimateType.Profits_OwnFunding),
                this.getEstimateTypeOption(EstimateType.Profits_CustomerFees),
                this.getEstimateTypeOption(EstimateType.Profits_OtherPublicAid),
                this.getEstimateTypeOption(EstimateType.Profits_Other)
            ];
            return optionsArray;
        },
        enumerable: false,
        configurable: true
    });
    BudgetaryEstimateView.prototype.getEstimateTypeOption = function (key) {
        return {
            id: key,
            name: this.$t("Enums.EstimateType." + EstimateType[key]).toString()
        };
    };
    BudgetaryEstimateView.prototype.setPremiseTotalExpenses = function (totals) {
        var otherExpenses = this.budgetaryEstimate.expenses.otherExpenses.summary;
        var premiseExpensesTotal = otherExpenses.find(function (x) { return x.type == EstimateType.Expenses_Other_PremiseExpenses; });
        premiseExpensesTotal.yearlyItems.forEach(function (x) {
            x.value = totals.find(function (total) { return total.year == x.year; }).total;
        });
    };
    var _a, _b;
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_a = typeof BudgetaryEstimate !== "undefined" && BudgetaryEstimate) === "function" ? _a : Object)
    ], BudgetaryEstimateView.prototype, "budgetaryEstimate", void 0);
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_b = typeof AidTypeSpecification !== "undefined" && AidTypeSpecification) === "function" ? _b : Object)
    ], BudgetaryEstimateView.prototype, "specification", void 0);
    __decorate([
        Prop({ type: Number, required: true }),
        __metadata("design:type", Number)
    ], BudgetaryEstimateView.prototype, "applicationYear", void 0);
    __decorate([
        Watch("showGrantorsAndPurposes"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], BudgetaryEstimateView.prototype, "onManuallyAddedProfitsChange", null);
    BudgetaryEstimateView = __decorate([
        Component({
            name: "BudgetaryEstimateView",
            components: {
                LabelControl: LabelControl,
                PlainTextControl: PlainTextControl,
                PersonnelExpensesControl: PersonnelExpensesControl,
                GeneralExpensesControl: GeneralExpensesControl,
                OtherExpensesControl: OtherExpensesControl,
                EstimatesControl: EstimatesControl,
                EstimatesAndDetailsControl: EstimatesAndDetailsControl,
                DelegationControl: DelegationControl,
                PremisesControl: PremisesControl,
                AttachmentRow: AttachmentRow,
                SupportApartmentsBudgetaryEstimateView: SupportApartmentsBudgetaryEstimateView,
                PremisesBudgetaryEstimateView: PremisesBudgetaryEstimateView,
                IctBudgetaryEstimateView: IctBudgetaryEstimateView,
                TextAreaRow: TextAreaRow
            }
        })
    ], BudgetaryEstimateView);
    return BudgetaryEstimateView;
}(Mixins(Savable)));
export default BudgetaryEstimateView;
